import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { compose, mapProps } from 'recompose';
import { styled } from '@rexlabs/styling'; // Core component

import TextInputView from './text-input-view';
import meta from './text-input-meta';
import styles from './text-input-styles'; // Higher Order Components (behaviour)

import withBehaviour from './behaviour';
var assign = _Object$assign;
var sanitizeProps = mapProps(function (_ref) {
  var uncontrolled = _ref.uncontrolled,
      isFocused = _ref.isFocused,
      errors = _ref.errors,
      valid = _ref.valid,
      dirty = _ref.dirty,
      props = _objectWithoutProperties(_ref, ["uncontrolled", "isFocused", "errors", "valid", "dirty"]);

  return props;
});
export var TextInputInternal = compose(withBehaviour, sanitizeProps)(TextInputView);
var TextInput = assign(function (props) {
  return React.createElement(TextInputInternal, props);
}, _objectSpread({}, meta, {
  displayName: 'TextInput'
}));
export default styled(styles)(TextInput);